export enum OperationTarget {
    USER = "USER",
    CARE_RECIPIENT = "CARE_RECIPIENT"
}

export const getOperationTargetFromValue = (value: string): OperationTarget => {
    switch (value.toUpperCase()) {
        case "USER": {
            return OperationTarget.USER;
        }
        case "CARE_RECIPIENT": {
            return OperationTarget.CARE_RECIPIENT;
        }
        default: {
            return OperationTarget.USER;
        }
    }
};

export const getLabelFromOperationTarget = (operationTarget: OperationTarget): string =>{
    switch (operationTarget) {
        case OperationTarget.USER: {
            return "ユーザー";
        }
        case OperationTarget.CARE_RECIPIENT: {
            return "利用者";
        }
        default: {
            return "ユーザー";
        }
    }
};
